export enum  MonthsEnum {
    JANUARY = 1,
    FEBRUARY,
    MARCH,
    APRIL,
    MAY,
    JUNE,
    JULY,
    AUGUST,
    SEPTEMBER,
    OCTOBER,
    NOVEMBER,
    DECEMBER
}

export enum CalendarYears {
    CURRENT = new Date().getFullYear(),
    NEXT = CURRENT+1,
    PREVIUS = CURRENT-1
}